<template>
    <div>
        <CustomerComponent :isCreate="true"></CustomerComponent>
    </div>
</template>

<script>
    import CustomerComponent from "./component/CustomerComponent"

    export default {
        name: "CustomerCreate",
        components: {
            CustomerComponent
        },
        data() {
            return {
                options: []
            }
        },
        methods: {

        },
        mounted(){

        },
    }
</script>

<style scoped>

</style>
